/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
import { calculatedBaseFontSize } from './base-font-size.js';

const STEP_TICK_RADIUS = 0.5 / calculatedBaseFontSize;

export const SliderStepMarkerMixin = (base) =>
  class StepMarkerMixin extends base {
    constructor() {
      super();
      this.min = 0;
      this.max = 100;
      this.step = 1;
    }

    getCalculatedStepDistance(containerLength, min, max, step) {
      let distance;
      this.min = min;
      this.max = max;
      this.step = step;
      distance = this.step / (this.max - this.min);
      distance = distance * containerLength - STEP_TICK_RADIUS;
      return { distance };
    }

    calculatePoints(containerLength) {
      let value;
      let points = [];
      const marker_pos = Math.floor((this.max - this.min) / this.step);
      if (this.min < 0 && this.min / this.step != 0) {
        points = [0];
        value = 0;
        let marker_pos_minus = Math.floor((0 - this.min) / this.step);
        let marker_pos_plus = Math.floor((this.max - 0) / this.step);
        for (let i = 0; i < marker_pos_minus; ++i) {
          value = value - this.step;
          points.push(value);
        }
        value = 0;
        for (let i = 0; i < marker_pos_plus; ++i) {
          value = value + this.step;
          points.push(value);
        }
      } else {
        // when min is positive and divisible by step value
        points = [this.min];
        value = this.min;
        for (let i = 0; i < marker_pos; ++i) {
          value = value + this.step;
          points.push(value);
        }
      }
      // map the values in points array
      this._calculateStepTicks(points, containerLength);
    }

    _calculateStepTicks(points, containerLength) {
      let current_position, style;
      const stepMarkers = points.map((value) => {
        current_position = (value - this.min) / (this.max - this.min);
        current_position =
          (2 * Math.round((current_position * containerLength) / 2)) / calculatedBaseFontSize;
        current_position -= STEP_TICK_RADIUS;
        style = `left: ${current_position}rem`;
        return { style, position: value };
      });
      this.setReadOnlyProperties({ stepMarkers: stepMarkers });
    }
  };
